/** Vrste oseb (pot API-ja /api/osebe/{vrsta}) z nazivi (PregledOseb). */
export const VRSTE = [
  { kljuc: 'kupci', naziv: 'Kupci', ednina: 'Kupec', nova: 'Nov kupec' },
  { kljuc: 'prodajalci', naziv: 'Prodajalci', ednina: 'Prodajalec', nova: 'Nov prodajalec' },
  { kljuc: 'uporabniki-vozil', naziv: 'Uporabniki vozil', ednina: 'Uporabnik vozila', nova: 'Nov uporabnik vozila' },
] as const;

export type Vrsta = (typeof VRSTE)[number];

export function vrsta(kljuc: string | null | undefined): Vrsta {
  return VRSTE.find((v) => v.kljuc === kljuc) ?? VRSTE[0];
}

/** »Ulica 1, 1000 Ljubljana« */
export function naslov(o: { ulica?: string; hisnaStevilka?: string; postnaStevilka?: string; kraj?: string }): string {
  const ulica = [o.ulica, o.hisnaStevilka].filter(Boolean).join(' ');
  const kraj = [o.postnaStevilka, o.kraj].filter(Boolean).join(' ');
  return [ulica, kraj].filter(Boolean).join(', ');
}

export function imeOsebe(o?: { ime?: string; priimek?: string }): string {
  return [o?.ime, o?.priimek].filter(Boolean).join(' ');
}

// pravne oblike (d.o.o., s.p., d.d., k.d., d.n.o., z.o.o.) – podjetje ima ves naziv v imenu, kot v obstoječih podatkih
const PODJETJE = /\b(d\.?\s?o\.?\s?o|s\.?\s?p|d\.?\s?d|k\.?\s?d|d\.?\s?n\.?\s?o|z\.?\s?o\.?\s?o)\.?(\s|$)/i;

/**
 * Iskalno besedilo za novo osebo: »Janez Novak« → ime Janez, priimek Novak (prva beseda ime, ostalo priimek);
 * podjetje (pravna oblika ali številka v besedilu, npr. »Avto Špica d.o.o.«) in ena beseda gresta v celoti v ime.
 */
export function razdeliIme(besedilo: string): { ime: string; priimek: string } {
  const b = besedilo.trim().replace(/\s+/g, ' ');
  const presledek = b.indexOf(' ');
  if (presledek < 0 || PODJETJE.test(b) || /\d/.test(b)) {
    return { ime: b, priimek: '' };
  }
  return { ime: b.slice(0, presledek), priimek: b.slice(presledek + 1) };
}
